import type { TTabItem } from '../conversation-list-section.types';
import { Title } from '../conversation-list-section.styles';

export const FILTER_DEBOUNCE_MS = 1000;

export const TAB_ITEMS: TTabItem[] = [
	{
		title: 'Comprando',
		customStyle: Title
	},
	{
		title: 'Vendendo',
		customStyle: Title
	}
];
